export const DATE_FORMAT = {
  DATE_TIME_NUMBER: 'PPp',
  MONTH_DAY_YEAR: 'LLL d, yyyy',
  DATE_DOTS_TIME_NUMBER: 'dd.MM.yyyy, hh:mma',
  DAY_MONTH_YEAR: 'dd.MM.yyyy',
  MONTH_YEAR: 'LLL Y',
  MONTH_YEAR_SHORT: 'LLL’yy',
  MONTH_DAY: 'LLL dd',
  TIME_WITH_SECONDS: 'hh:mm:ss aa',
  MONTH_DAY_YEAR_TIME: 'LLL d, yyyy • hh:mm:ss',
  YEAR_MONTH_DATE: 'yyyy-MM-dd',
};
